import { useRef } from 'react'
import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, A11y } from 'swiper/modules'
import { Props_SnippetQuotesCarousel } from './QuotesCarousel.props'
import SwiperControls, { swiperNavigationOptions, swiperPaginationOptions } from '../Shared/SwiperControls/SwiperControls'
import SnippetLink from '../Shared/Link/Link'

const SnippetQuotesCarousel = (props: Props_SnippetQuotesCarousel) => {
    const { heading, repeatable_quote } = props
    const classHeadingVisibility: string = heading.visibility?.value === "hidden" ? ` snippet-quotes-carousel__heading--${heading.visibility.value}` : ''
    const snippetRef = useRef<HTMLElement | null>(null)

    const carouselId = "quotes-carousel"

    return (
        <section ref={snippetRef} className="snippet-quotes-carousel">
            <div className="snippet-quotes-carousel__container">
                <h2 className={`snippet-quotes-carousel__heading${classHeadingVisibility}`}>
                    
                    {heading.content.value }</h2>

                <Swiper
                    className="snippet-quotes-carousel__swiper"
                    modules={[Navigation, Pagination, A11y]}
                    navigation={{
                        ...swiperNavigationOptions,
                        prevEl: `.swiper-navigation__button-prev-${carouselId}`,
                        nextEl: `.swiper-navigation__button-next-${carouselId}`,
                    }}
                    pagination={{
                        ...swiperPaginationOptions,
                        el: `.swiper-pagination-${carouselId}`,
                    }}
                    slidesPerView={1}
                    watchOverflow={true}
                    watchSlidesProgress={true}
                >
                    {repeatable_quote.map((entry, index) => (
                        <SwiperSlide key={index} className="snippet-quotes-carousel__swiper-slide">
                            <div className="snippet-quotes-carousel__container-quote">
                                <div className="snippet-quotes-carousel__container-quote-content">
                                    { entry.quote?.value && <blockquote className="snippet-quotes-carousel__quote-content">{ CompileMarkdown(entry.quote?.value)}</blockquote> }
                                    <div className="snippet-quotes-carousel__container-quote-details">
                                        { entry.author?.value && <p className="snippet-quotes-carousel__quote-author">{entry.author?.value}</p> }
                                        { entry.role?.value && <p className="snippet-quotes-carousel__quote-role">{entry.role?.value}</p> }
                                        { entry.area?.value && <p className="snippet-quotes-carousel__quote-area">{entry.area?.value}</p> }
                                    </div>
                                </div>
                                <SnippetLink
                                    linkStyles={entry.linkStyle?.value}
                                    className="snippet-quotes-carousel__entry-link"
                                    url={entry.linkHref?.value}
                                    target={entry.linkTarget?.value}
                                >
                                    {entry.linkContent?.value}
                                </SnippetLink>
                            </div>
                            <img
                                className="snippet-quotes-carousel__quote-image"
                                loading="lazy"
                                width={640}
                                height={640}
                                src={entry.image?.value}
                                alt={entry.alt?.value || ''}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
                <SwiperControls
                    uniqueId={carouselId}
                    className="snippet-quotes-carousel__navigation"
                />
            </div>
        </section>
    )
}

export default SnippetQuotesCarousel